import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type ToggleActivePayload = {
  id: EntityId
}

export const toggleDriverStatus = createAsyncThunk('drivers/toggleActive', async ({ id }: ToggleActivePayload) => {
  const results = await OLMSApiService.post<number>('/driver/toggleActive', id)

  return results
})